import { render } from "./MainNav.vue?vue&type=template&id=12c5358f"
import script from "./MainNav.vue?vue&type=script&lang=js"
export * from "./MainNav.vue?vue&type=script&lang=js"

import "./MainNav.vue?vue&type=style&index=0&id=12c5358f&lang=scss"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__